export enum DeleteVehicleReasonTypesEnum {
  Stolen = 'Stolen',
  Sold = 'Sold',
  IncorrectAddress = 'IncorrectAddress',
  Other = 'Other',
}
